module.exports = __webpack_public_path__ + "img/TradingView-img4.d8f02c7e.png";